import { put } from 'redux-saga/effects'
import { disconnectSocket } from '@/helpers/socket'
import { signOutAsync } from '../../actions'
import { updateOnFirebase } from '@/redux/chat/sagas/_http/user'

export function* signOutSaga(action: ReturnType<typeof signOutAsync.request>) {
  const { id } = action.payload
  try {
    disconnectSocket()
    localStorage.removeItem('devchat_app_userAuthenticated')
    localStorage.removeItem('devchat_app_selectedCompanyId')
    localStorage.removeItem('devchat_app_selectedCompanyOwnerId')
    localStorage.removeItem('devchat_app_selectedDepartment')
    yield updateOnFirebase(id, { isWork: false })
    yield put(signOutAsync.success())
  } catch (error) {
    yield put(signOutAsync.failure(error))
  }
}
